import JSONAPI, { Attribute } from "@mediamonks/jsonapi-client";
import { isString, isNumber, isBoolean } from "isntnt";

export class Diamond extends JSONAPI.resource("diamonds", "diamonds")<Diamond> {
    @Attribute.required(isString) public sku!: string;
    @Attribute.required(isString) public shape!: string;
    @Attribute.required(isNumber) public carat!: number;
    @Attribute.required(isString) public color!: string;
    @Attribute.required(isString) public clarity!: string;
    @Attribute.required(isString) public cut!: string;
    @Attribute.required(isString) public polish!: string;
    @Attribute.required(isString) public symmetry!: string;
    @Attribute.required(isString) public fluorescence!: string;
    @Attribute.required(isNumber) public price!: number;
    @Attribute.required(isString) public certificateLink!: string;
    @Attribute.required(isNumber) public shopifyProductId!: number;
    @Attribute.required(isNumber) public shopifyVariantId!: number;
    @Attribute.required(isBoolean) public highlighted!: boolean;
    @Attribute.optional(isString) public videoLink!: string | null;
    @Attribute.required(isString) public createdAt!: string;
    @Attribute.required(isString) public updatedAt!: string;
}
